import(/* webpackMode: "eager" */ "/tmp/seed/source/app/login/LoginBox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Card"] */ "/tmp/seed/source/node_modules/@mantine/core/esm/components/Card/Card.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Center"] */ "/tmp/seed/source/node_modules/@mantine/core/esm/components/Center/Center.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/tmp/seed/source/node_modules/@mantine/core/esm/components/Image/Image.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Box"] */ "/tmp/seed/source/node_modules/@mantine/core/esm/core/Box/Box.mjs");
;
import(/* webpackMode: "eager" */ "/tmp/seed/source/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/seed/source/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
